<script lang="ts" setup>
    import HeroMedia from '~/components/heroElements/HeroMedia.vue';
    import UrologyHeroBackgroundAnimated from '~/components/urology/Hero/UrologyHeroBackgroundAnimated.vue';

    const props = defineProps<{ blok: HeroComponentStoryblok }>();
    const { headlineContent, asset, mediaSrc, mediaAlt, mediaContentType } = useHeroComponentContent(() => props.blok);
</script>

<template>
    <div
        v-editable="props.blok"
        class="hero-container"
    >
        <UrologyHeroBackgroundAnimated />
        <HeroMedia
            :media="asset"
            :src="mediaSrc"
            :alt="mediaAlt"
            :content-type="mediaContentType"
            storage-key="urology-hero-paused"
            variant="urology"
        />

        <div class="hero-wrapper">
            <div class="content">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="headline"
                    v-html="headlineContent"
                />
                <!-- eslint-enable vue/no-v-html -->

                <div
                    v-if="props.blok.button"
                    class="btn-wrapper"
                >
                    <ButtonLink
                        v-for="item in props.blok.button"
                        :key="item._uid"
                        :blok="item"
                    />
                </div>
            </div>
        </div>

        <HeroScrollDown />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/urology/urology-hero-section.scss';
</style>
